import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "nav nav-underline mb-3",
    role: "tablist"
};
const _hoisted_2 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_3 = ["id", "data-bs-target", "aria-controls"];
const _hoisted_4 = { class: "tab-content mb-4" };
const _hoisted_5 = ["id", "aria-labelledby"];
const _hoisted_6 = { class: "mb-4" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-lg-6 col-12" };
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = ["id", "onUpdate:modelValue"];
const _hoisted_12 = ["for"];
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = ["id", "onUpdate:modelValue"];
const _hoisted_15 = ["value"];
const _hoisted_16 = ["for"];
const _hoisted_17 = { class: "mb-3" };
const _hoisted_18 = { class: "form-check mb-2" };
const _hoisted_19 = ["value", "id", "onUpdate:modelValue"];
const _hoisted_20 = ["for"];
const _hoisted_21 = { class: "form-floating mb-3" };
const _hoisted_22 = ["id", "onUpdate:modelValue"];
const _hoisted_23 = ["for"];
const _hoisted_24 = { class: "input-group mb-3" };
const _hoisted_25 = { class: "form-floating" };
const _hoisted_26 = ["id", "onUpdate:modelValue"];
const _hoisted_27 = ["for"];
const _hoisted_28 = { class: "input-group mb-3" };
const _hoisted_29 = { class: "form-floating" };
const _hoisted_30 = ["id", "onUpdate:modelValue"];
const _hoisted_31 = ["for"];
const _hoisted_32 = { class: "input-group mb-3" };
const _hoisted_33 = { class: "form-floating" };
const _hoisted_34 = ["id", "onUpdate:modelValue"];
const _hoisted_35 = ["for"];
const _hoisted_36 = { class: "form-floating mb-3" };
const _hoisted_37 = ["onInput", "id"];
const _hoisted_38 = ["for"];
const _hoisted_39 = { class: "col-lg-6 col-12" };
const _hoisted_40 = { class: "d-flex align-items-center justify-content-center" };
const _hoisted_41 = ["src"];
const _hoisted_42 = {
    key: 1,
    class: "spinner-border text-primary mt-5",
    role: "status"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["id"];
const _hoisted_45 = { class: "accordion-item" };
const _hoisted_46 = { class: "accordion-header" };
const _hoisted_47 = ["data-bs-target"];
const _hoisted_48 = ["id", "data-bs-parent"];
const _hoisted_49 = { class: "accordion-body" };
const _hoisted_50 = { class: "accordion-item" };
const _hoisted_51 = { class: "accordion-header" };
const _hoisted_52 = ["data-bs-target"];
const _hoisted_53 = ["id", "data-bs-parent"];
const _hoisted_54 = { class: "accordion-body" };
const _hoisted_55 = { class: "accordion-item" };
const _hoisted_56 = { class: "accordion-header" };
const _hoisted_57 = ["data-bs-target"];
const _hoisted_58 = ["id", "data-bs-parent"];
const _hoisted_59 = { class: "accordion-body" };
const _hoisted_60 = { class: "accordion-item" };
const _hoisted_61 = { class: "accordion-header" };
const _hoisted_62 = ["data-bs-target"];
const _hoisted_63 = ["id", "data-bs-parent"];
const _hoisted_64 = { class: "accordion-body" };
const _hoisted_65 = { class: "accordion-item" };
const _hoisted_66 = { class: "accordion-header" };
const _hoisted_67 = ["data-bs-target"];
const _hoisted_68 = ["id", "data-bs-parent"];
const _hoisted_69 = { class: "accordion-body" };
const _hoisted_70 = { class: "accordion-item" };
const _hoisted_71 = { class: "accordion-header" };
const _hoisted_72 = ["data-bs-target"];
const _hoisted_73 = ["id", "data-bs-parent"];
const _hoisted_74 = { class: "accordion-body" };
const _hoisted_75 = {
    class: "modal fade",
    id: "createPrintArea",
    tabindex: "-1",
    "aria-labelledby": "createPrintAreaModalLabel",
    "aria-hidden": "true"
};
const _hoisted_76 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_77 = { class: "modal-content" };
const _hoisted_78 = { class: "modal-body" };
const _hoisted_79 = { class: "form-floating mb-3" };
const _hoisted_80 = { class: "form-floating mb-3" };
const _hoisted_81 = ["value"];
const _hoisted_82 = { class: "mb-3" };
const _hoisted_83 = { class: "form-check mb-2" };
const _hoisted_84 = ["value", "id"];
const _hoisted_85 = ["for"];
const _hoisted_86 = { class: "input-group mb-3" };
const _hoisted_87 = { class: "form-floating" };
const _hoisted_88 = { class: "input-group mb-3" };
const _hoisted_89 = { class: "form-floating" };
const _hoisted_90 = { class: "input-group mb-3" };
const _hoisted_91 = { class: "form-floating" };
const _hoisted_92 = { class: "form-floating mb-3" };
import { FilterMatchMode } from '@primevue/core/api';
import { router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
import { Modal } from 'bootstrap';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintAreas',
    props: {
        bottle: Object,
        printAreaTypes: Object,
        printModes: Object
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const emit = __emit;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const createPrintArea = useForm({
            name: null,
            printAreaWidth: null,
            printAreaHeight: null,
            printAreaBottomDistance: null,
            configImgFile: null,
            printAreaTypeId: null,
            printModeIds: []
        });
        const printAreas = ref(props.bottle?.printAreas ?? []);
        const loading = ref(true);
        const createPrintAreaModal = ref(null);
        onMounted(() => {
            const modalElement = document.getElementById('createPrintArea');
            if (modalElement) {
                createPrintAreaModal.value = new Modal(modalElement);
            }
            setTimeout(() => {
                loading.value = false;
            }, 1000);
        });
        function create() {
            if (props.bottle == null) {
                return;
            }
            createPrintArea.transform((data) => ({
                name: data.name,
                print_area_width: data.printAreaWidth,
                print_area_height: data.printAreaHeight,
                print_area_bottom_distance: data.printAreaBottomDistance,
                config_img_file: data.configImgFile,
                print_area_type_id: data.printAreaTypeId,
                print_mode_ids: data.printModeIds
            }))
                .submit('post', route('admin.bottles.printAreas.store', props.bottle.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createPrintAreaModal.value?.hide();
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function update(printArea) {
            router.post(route('admin.bottles.printAreas.update', printArea.uuid), {
                name: printArea.name,
                print_area_width: printArea.printAreaWidth,
                print_area_height: printArea.printAreaHeight,
                print_area_bottom_distance: printArea.printAreaBottomDistance,
                config_img_file: printArea.configImgFile,
                print_area_type_id: printArea.printAreaTypeId,
                print_mode_ids: printArea.printModeIds,
                max_colors: printArea.maxColors
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove(printArea) {
            confirm.require({
                message: 'Soll der Druckbereich wirklich gelöscht werden?',
                header: 'Druckbereich löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.bottles.printAreas.destroy', printArea.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                            emit('update');
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[27] || (_cache[27] = _createElementVNode("button", {
                    class: "btn btn-secondary d-inline-flex align-items-center mb-4",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#createPrintArea"
                }, [
                    _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-plus-lg",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                        })
                    ]),
                    _createElementVNode("span", { class: "ms-2" }, "Neuer Druckbereich")
                ], -1)),
                _createElementVNode("ul", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printAreas.value, (printArea, index) => {
                        return (_openBlock(), _createElementBlock("li", _hoisted_2, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["nav-link", { active: Number(index) == 0 }]),
                                id: 'printArea-tab' + index,
                                "data-bs-toggle": "tab",
                                "data-bs-target": '#printArea-tab-pane' + index,
                                type: "button",
                                role: "tab",
                                "aria-controls": 'printArea-tab-pane' + index,
                                "aria-selected": "true"
                            }, _toDisplayString(index + 1) + ". Druckbereich", 11, _hoisted_3)
                        ]));
                    }), 256))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printAreas.value, (printArea, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["tab-pane fade", { 'show active': Number(index) == 0 }]),
                            id: 'printArea-tab-pane' + index,
                            role: "tabpanel",
                            "aria-labelledby": 'printArea-tab' + index,
                            tabindex: "0"
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(($event) => (update(printArea)), ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: 'printAreaName' + index,
                                                    "onUpdate:modelValue": ($event) => ((printArea.name) = $event),
                                                    required: ""
                                                }, null, 8, _hoisted_11), [
                                                    [_vModelText, printArea.name]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'printAreaName' + index
                                                }, "Name", 8, _hoisted_12)
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'printAreaType' + index,
                                                    "onUpdate:modelValue": ($event) => ((printArea.printAreaTypeId) = $event),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.printAreaTypes, (printAreaType) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: printAreaType.id
                                                        }, _toDisplayString(printAreaType.name), 9, _hoisted_15));
                                                    }), 256))
                                                ], 8, _hoisted_14), [
                                                    [_vModelSelect, printArea.printAreaTypeId]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'printAreaType' + index
                                                }, "Druckbereichs-Typ", 8, _hoisted_16)
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.printModes, (printMode, index2) => {
                                                    return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            class: "form-check-input",
                                                            type: "checkbox",
                                                            value: printMode.id,
                                                            id: 'printMode' + index + index2,
                                                            "onUpdate:modelValue": ($event) => ((printArea.printModeIds) = $event)
                                                        }, null, 8, _hoisted_19), [
                                                            [_vModelCheckbox, printArea.printModeIds]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            class: "form-check-label",
                                                            for: 'printMode' + index + index2
                                                        }, _toDisplayString(printMode.name), 9, _hoisted_20)
                                                    ]));
                                                }), 256))
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    id: 'printAreaMaxColors' + index,
                                                    class: "form-control",
                                                    min: "1",
                                                    "onUpdate:modelValue": ($event) => ((printArea.maxColors) = $event),
                                                    required: ""
                                                }, null, 8, _hoisted_22), [
                                                    [_vModelText, printArea.maxColors]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'printAreaMaxColors' + index
                                                }, "Maximale Farbanzahl", 8, _hoisted_23)
                                            ]),
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        id: 'printAreaWidth' + index,
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": ($event) => ((printArea.printAreaWidth) = $event),
                                                        required: ""
                                                    }, null, 8, _hoisted_26), [
                                                        [_vModelText, printArea.printAreaWidth]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'printAreaWidth' + index
                                                    }, "Druckbereich-Breite", 8, _hoisted_27)
                                                ]),
                                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        id: 'printAreaHeight' + index,
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": ($event) => ((printArea.printAreaHeight) = $event),
                                                        required: ""
                                                    }, null, 8, _hoisted_30), [
                                                        [_vModelText, printArea.printAreaHeight]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'printAreaHeight' + index
                                                    }, "Druckbereich-Höhe", 8, _hoisted_31)
                                                ]),
                                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        id: 'printAreaBottomDistance' + index,
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": ($event) => ((printArea.printAreaBottomDistance) = $event),
                                                        required: ""
                                                    }, null, 8, _hoisted_34), [
                                                        [_vModelText, printArea.printAreaBottomDistance]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'printAreaBottomDistance' + index
                                                    }, "Druckbereich-Distanz zum Flaschen-Boden", 8, _hoisted_35)
                                                ]),
                                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("input", {
                                                    type: "file",
                                                    onInput: ($event) => (printArea.configImgFile = $event.target.files[0]),
                                                    class: "form-control",
                                                    id: 'printAreaConfigImgFile' + index
                                                }, null, 40, _hoisted_37),
                                                _createElementVNode("label", {
                                                    for: 'printAreaConfigImgFile' + index
                                                }, "Konfigurations-Datei", 8, _hoisted_38)
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 40, _hoisted_9)
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                        _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "bg-primary text-white px-3 py-2 mb-4" }, "Konfigurations-Bild", -1)),
                                        _createElementVNode("div", _hoisted_40, [
                                            (!loading.value)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: printArea.configImgUrl,
                                                    alt: "Konfigurations-Bild",
                                                    style: { "height": "400px", "max-width": "100%" }
                                                }, null, 8, _hoisted_41))
                                                : _createCommentVNode("", true),
                                            (loading.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[12] || (_cache[12] = [
                                                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]),
                                (printArea.canRemove)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: ($event) => (remove(printArea))
                                    }, [...(_cache[14] || (_cache[14] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Druckbereich löschen", -1)
                                        ]))], 8, _hoisted_43))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                                _createElementVNode("div", {
                                    class: "accordion accordion-flush",
                                    id: 'pricesAccordion' + index
                                }, [
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("h2", _hoisted_46, [
                                            _createElementVNode("button", {
                                                class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#color1PricesAccordion' + index
                                            }, " 1-farbiger Druck ", 8, _hoisted_47)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'color1PricesAccordion' + index,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": '#pricesAccordion' + index
                                        }, [
                                            _createElementVNode("div", _hoisted_49, [
                                                _createVNode(ProductPriceOption, {
                                                    bottlePrintArea: printArea,
                                                    colorType: 1,
                                                    priceBundleUuid: printArea.color1PriceBundleUuid
                                                }, null, 8, ["bottlePrintArea", "priceBundleUuid"])
                                            ])
                                        ], 8, _hoisted_48)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("h2", _hoisted_51, [
                                            _createElementVNode("button", {
                                                class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#color2PricesAccordion' + index
                                            }, " 2-farbiger Druck ", 8, _hoisted_52)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'color2PricesAccordion' + index,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": '#pricesAccordion' + index
                                        }, [
                                            _createElementVNode("div", _hoisted_54, [
                                                _createVNode(ProductPriceOption, {
                                                    bottlePrintArea: printArea,
                                                    colorType: 2,
                                                    priceBundleUuid: printArea.color2PriceBundleUuid
                                                }, null, 8, ["bottlePrintArea", "priceBundleUuid"])
                                            ])
                                        ], 8, _hoisted_53)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("h2", _hoisted_56, [
                                            _createElementVNode("button", {
                                                class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#color3PricesAccordion' + index
                                            }, " 3-farbiger Druck ", 8, _hoisted_57)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'color3PricesAccordion' + index,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": '#pricesAccordion' + index
                                        }, [
                                            _createElementVNode("div", _hoisted_59, [
                                                _createVNode(ProductPriceOption, {
                                                    bottlePrintArea: printArea,
                                                    colorType: 3,
                                                    priceBundleUuid: printArea.color3PriceBundleUuid
                                                }, null, 8, ["bottlePrintArea", "priceBundleUuid"])
                                            ])
                                        ], 8, _hoisted_58)
                                    ]),
                                    _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("h2", _hoisted_61, [
                                            _createElementVNode("button", {
                                                class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#color4PricesAccordion' + index
                                            }, " 4-farbiger Druck ", 8, _hoisted_62)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'color4PricesAccordion' + index,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": '#pricesAccordion' + index
                                        }, [
                                            _createElementVNode("div", _hoisted_64, [
                                                _createVNode(ProductPriceOption, {
                                                    bottlePrintArea: printArea,
                                                    colorType: 4,
                                                    priceBundleUuid: printArea.color4PriceBundleUuid
                                                }, null, 8, ["bottlePrintArea", "priceBundleUuid"])
                                            ])
                                        ], 8, _hoisted_63)
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("h2", _hoisted_66, [
                                            _createElementVNode("button", {
                                                class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#digitalPricesAccordion' + index
                                            }, " Digital-Druck ", 8, _hoisted_67)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'digitalPricesAccordion' + index,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": '#pricesAccordion' + index
                                        }, [
                                            _createElementVNode("div", _hoisted_69, [
                                                _createVNode(ProductPriceOption, {
                                                    bottlePrintArea: printArea,
                                                    colorType: 0,
                                                    priceBundleUuid: printArea.digitalPriceBundleUuid
                                                }, null, 8, ["bottlePrintArea", "priceBundleUuid"])
                                            ])
                                        ], 8, _hoisted_68)
                                    ]),
                                    _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("h2", _hoisted_71, [
                                            _createElementVNode("button", {
                                                class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                                type: "button",
                                                "data-bs-toggle": "collapse",
                                                "data-bs-target": '#gravurePricesAccordion' + index
                                            }, " Gravur-Druck ", 8, _hoisted_72)
                                        ]),
                                        _createElementVNode("div", {
                                            id: 'gravurePricesAccordion' + index,
                                            class: "accordion-collapse collapse",
                                            "data-bs-parent": '#pricesAccordion' + index
                                        }, [
                                            _createElementVNode("div", _hoisted_74, [
                                                _createVNode(ProductPriceOption, {
                                                    bottlePrintArea: printArea,
                                                    colorType: 11,
                                                    priceBundleUuid: printArea.gravurePriceBundleUuid
                                                }, null, 8, ["bottlePrintArea", "priceBundleUuid"])
                                            ])
                                        ], 8, _hoisted_73)
                                    ])
                                ], 8, _hoisted_44)
                            ])
                        ], 10, _hoisted_5));
                    }), 256))
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createPrintAreaModalLabel"
                                    }, "Neuer Druckbereich"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event) => (create()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(createPrintArea).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createPrintArea).name]
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_80, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "printAreaType",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(createPrintArea).printAreaTypeId) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.printAreaTypes, (printAreaType) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: printAreaType.id
                                                    }, _toDisplayString(printAreaType.name), 9, _hoisted_81));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(createPrintArea).printAreaTypeId]
                                            ]),
                                            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "printAreaType" }, "Druckbereichs-Typ", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_82, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.printModes, (printMode, index) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        value: printMode.id,
                                                        id: 'newPrintMode' + index,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createPrintArea).printModeIds) = $event))
                                                    }, null, 8, _hoisted_84), [
                                                        [_vModelCheckbox, _unref(createPrintArea).printModeIds]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: 'newPrintMode' + index
                                                    }, _toDisplayString(printMode.name), 9, _hoisted_85)
                                                ]));
                                            }), 256))
                                        ]),
                                        _createElementVNode("div", _hoisted_86, [
                                            _createElementVNode("div", _hoisted_87, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    id: "printAreaWidth",
                                                    class: "form-control",
                                                    min: "0",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createPrintArea).printAreaWidth) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(createPrintArea).printAreaWidth]
                                                ]),
                                                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "printAreaWidth" }, "Druckbereich-Breite", -1))
                                            ]),
                                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("div", _hoisted_89, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    id: "printAreaHeight",
                                                    class: "form-control",
                                                    min: "0",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createPrintArea).printAreaHeight) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(createPrintArea).printAreaHeight]
                                                ]),
                                                _cache[20] || (_cache[20] = _createElementVNode("label", { for: "printAreaHeight" }, "Druckbereich-Höhe", -1))
                                            ]),
                                            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_90, [
                                            _createElementVNode("div", _hoisted_91, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    id: "printAreaBottomDistance",
                                                    class: "form-control",
                                                    min: "0",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createPrintArea).printAreaBottomDistance) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(createPrintArea).printAreaBottomDistance]
                                                ]),
                                                _cache[22] || (_cache[22] = _createElementVNode("label", { for: "printAreaBottomDistance" }, "Druckbereich-Distanz zum Flaschen-Boden", -1))
                                            ]),
                                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_92, [
                                            _createElementVNode("input", {
                                                type: "file",
                                                onInput: _cache[6] || (_cache[6] = ($event) => (_unref(createPrintArea).configImgFile = $event.target.files[0])),
                                                class: "form-control",
                                                id: "configImgFile",
                                                required: ""
                                            }, null, 32),
                                            _cache[24] || (_cache[24] = _createElementVNode("label", { for: "configImgFile" }, "Konfigurations-Datei", -1))
                                        ])
                                    ]),
                                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
